/**
 * /eric/reports/$reportId — Single progression report review (T-081, PR-21,
 * AI-06).
 *
 * Route config only. Component lives in eric.reports.$reportId.lazy.tsx
 * (code-split). No loader, beforeLoad, or validateSearch.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/reports/$reportId')({});
